export enum ProspectsQueryParams {
  businessUnits = 'prospect_business_units',
  owners = 'sales_representative_users',
  withoutContract = 'prospect_without_contract',
  withoutSalesRepresentativeUser = 'without_sales_representative_user',
  contractStatus = 'contract_status',
  companyLinked = 'company_linked',
  prestations = 'prestations',
  tiimeBusinessProAccountIntention = 'tiime_business_pro_account_intention',
  prospectAppointmentDate = 'prospect_appointment_date',
  acquisitionChannels = 'acquisition_channels'
}
